<template>
    <transition name="fade" v-if="enableTool">
        <control-printvisible
            :moduleCode="moduleCode"
            :panelID="pageID"
            :posBtnMap="mapButtons.print_visible_emissions.position"
            :idxBtnMap="mapButtons.print_visible_emissions.order"
            :showLabelBtnMap="mapButtons.print_visible_emissions.showLabel"
            :collapsible="mapButtons.print_visible_emissions.collapsible"
            :collapsed="initialCollapsedExpandCollapse"
            :showButtonOnActionMap="showButtonOnActionMap"
        >
        </control-printvisible>
    </transition>
</template>



<script>
    import ToolMixin from './mixins/ToolMixin';

    export default {
        mixins: [
            ToolMixin,
        ],
        components: {
            ControlPrintvisible: () => import(/* webpackChunkName: "control-printvisible" */ '@/components/maps/control/printControl'),
        },
        data() {
            return {
                pageID: 'print_visible_emissions'
            }
        },
    }
</script>